import { Shield, Clock, Star, BadgeCheck } from "lucide-react";
import { useLang } from "@/lib/i18n";

const ICONS = [Shield, Clock, Star, BadgeCheck];

export default function WhyChooseUs() {
  const { t } = useLang();
  const pillars = t("why.pillars");
  const stats = t("why.stats");
  return (
    <section id="about" data-testid="why-choose-us-section" className="relative py-28 lg:py-32 px-6 lg:px-10 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">{t("why.eyebrow")}</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white font-light tracking-tight mb-8">
              {t("why.title")}
            </h2>
            <p className="text-zinc-400 leading-relaxed mb-8">{t("why.body")}</p>

            <div className="grid grid-cols-2 gap-6 pt-8 border-t border-white/10">
              {stats.map((s) => (
                <div key={s.label}>
                  <p className="font-display text-4xl text-[#C5A059] font-light">{s.value}</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {pillars.map((p, i) => {
              const Icon = ICONS[i];
              return (
                <div
                  key={p.title}
                  data-testid={`pillar-${i}`}
                  className="bg-[#0d0d0d] border border-white/10 rounded-xl p-7 hover:border-[#C5A059]/40 transition-colors"
                >
                  <Icon className="w-6 h-6 text-[#C5A059] mb-5 stroke-[1.25]" />
                  <h3 className="font-display text-xl text-white font-normal mb-2">{p.title}</h3>
                  <p className="text-sm text-zinc-400 leading-relaxed">{p.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
